import { gql } from "@apollo/client";

export const RefreshCaseCache= gql`
mutation RefreshCaseCache($refreshPayload: RefreshCachePayload!) {
  RefreshCaseCache(refreshPayload: $refreshPayload) {
    message
  }
}
`;
